export enum LoginLocalePrefix {
  LOGIN = 'login',
  PASSWORD_RESET = 'passwordReset',
}
